// utils/sweetAlert.js
import Swal from 'sweetalert2';

// แจ้งเตือนเมื่อสำเร็จ (เช่น สร้างข้อมูล)
export const alertCreateSuccess = (message = 'บันทึกข้อมูลเรียบร้อยแล้ว') => {
    Swal.fire({
        title: 'สำเร็จ',
        text: message,
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,

    });
};

// แจ้งเตือนเมื่ออัปเดตสำเร็จ
export const alertUpdateSuccess = (message = 'อัปเดตข้อมูลเรียบร้อยแล้ว') => {
    Swal.fire({
        title: 'สำเร็จ',
        text: message,
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,

    });
};

// แจ้งเตือนเมื่อเกิดข้อผิดพลาด
export const alertError = (message = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง') => {
    Swal.fire({
        title: 'ผิดพลาด',
        text: message,
        icon: 'error',
        showConfirmButton: false,
        timer: 1500,

    });
};

// แจ้งเตือนเมื่อลบข้อมูลสำเร็จ
export const alertDeleteSuccess = (message = 'ลบข้อมูลเรียบร้อยแล้ว') => {
    Swal.fire({
        title: 'ลบข้อมูลแล้ว',
        text: message,
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,

    });
};

// แจ้งเตือนเพื่อยืนยันการลบ
export const showConfirmationAlert = (item, onConfirm) => {
    Swal.fire({
        title: 'คุณแน่ใจหรือไม่?',
        text: `คุณต้องการลบ "${item.name}" หรือไม่? ข้อมูลนี้ไม่สามารถย้อนกลับได้`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#d33',
        dangerMode: true,
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm();
        }
    });
};

// Success alert
export const showSuccessAlert = (
    title = 'สำเร็จ',
    message = 'ดำเนินการเรียบร้อยแล้ว'
) => {
    Swal.fire(title, message, 'success');
};

// Error alert
export const showErrorAlert = (
    title = 'เกิดข้อผิดพลาด',
    message = 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง'
) => {
    Swal.fire(title, message, 'error');
};
// General alert with customizable title, message, and type
export const showAlert = (
    title = 'แจ้งเตือน',
    message = '',
    type = 'info'
) => {
    Swal.fire(title, message, type);
};